(function () {
  'use strict';

  angular.module('ringbaPortal').component('pingTreeTargetForm', {
    bindings: {
      currentPingTreeTarget: '<',
      addRouteEnabled: '<',
      isModal: '<',
      addRoute: '&',
      onSave: '&',
      onDismiss: '&',
      isRtbRttResponse: '<'
    },
    controller: PingTreeTargetFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/select-target/ping-tree-target-form.view.html'
  });

  function PingTreeTargetFormController(
    _,
    $scope,
    $timeout,
    $q,
    $filter,
    $uibModal,
    accountsService,
    accountSettingsService,
    infoService,
    tagService,
    callbackService,
    pingTreeTargetService,
    authConnectionService,
    targetService,
    buyerService,
    capSettingsService,
    toaster,
    utils
  ) {

    'ngInject';

    const vm = this;

    vm.callTypes = pingTreeTargetService.callTypes;
    vm.newPingTreeTargetForm = {};
    vm.regex_digits_optional = new RegExp('\\d*');
    vm.currentCallRoute = {};
    vm.callCaps = {};

    vm.rpcSettingInContext;
    vm.parentRPCSettings;
    vm.parentRPCSettingLabel;
    vm.overrideRpcSetting = false;
    vm.isRpcSettingReadOnly = false;
    vm.buyerExternalLink;
    vm.isRefreshingBuyers = false;

    vm.targetOwnerCopy = null; // Maintain copy of owner ID, in case we need to call the unlink buyer
    vm.currentSelectedOwner = null; // Maintain copy of the selected owner so we can pass it to the dupe settings
    vm.save = save;
    vm.setHours = false;
    vm.isTagFilterSectionOpen = false;
    vm.showFullWidthOptions = {
      showSummaryView: false
    };
    vm.headers = [];
    vm.httpMethods = [
      { name: 'GET', value: 'get' },
      { name: 'POST', value: 'post' },
      { name: 'PUT', value: 'put' },
      { name: 'PATCH', value: 'patch' },
      { name: 'DELETE', value: 'delete' }
    ];
    vm.contentTypes = [
      { name: 'application/json', value: 'application/json' },
      { name: 'application/xml', value: 'application/xml' },
      { name: 'application/x-www-form-urlencoded', value: 'application/x-www-form-urlencoded' },
      { name: 'text/plain', value: 'text/plain' },
    ];

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.onScheduleChange = onScheduleChange;
    vm.showOwner = showOwner;
    vm.showType = showType;
    vm.validateDuplicacy = validateDuplicacy;
    vm.onCallTypeChange = onCallTypeChange;
    vm.showTagFilterSection = showTagFilterSection;
    vm.removeAllFilters = removeAllFilters;
    vm.confirmResetCapCounters = confirmResetCapCounters;
    vm.resetCapCounters = resetCapCounters;
    vm.cancelModal = cancelModal;
    vm.setSelectedOwner = setSelectedOwner;
    vm.onTargetDupeSettingsChange = onTargetDupeSettingsChange;
    vm.targetCapTypes = pingTreeTargetService.targetCapTypes;
    vm.emptyConcurrency = emptyConcurrency;
    vm.matrixUpdated = matrixUpdated;
    vm.onRPCSettingsChange = onRPCSettingsChange;
    vm.onRPCChange = onRPCChange;
    vm.onPriorityBumpChange = onPriorityBumpChange;
    vm.onRPCSettingToggled = onRPCSettingToggled;
    vm.onNumberChange = onNumberChange;
    vm.onToggleRTBShareableTags = onToggleRTBShareableTags;
    vm.onAcceptanceParsingChange = onAcceptanceParsingChange;
    vm.onDynamicNumberParsingChange = onDynamicNumberParsingChange;
    vm.onDynamicBidParsingChange = onDynamicBidParsingChange;
    vm.onDynamicDurationParsingChange = onDynamicDurationParsingChange;
    vm.sanitizeParsingForDisplay = sanitizeParsingForDisplay;
    vm.resetSettingsForBasic = resetSettingsForBasic;

    vm.onBidIdRequiredChange = onBidIdRequiredChange;
    vm.onUseConfirmationRequestNumberChange = onUseConfirmationRequestNumberChange;
    vm.onConfirmationRequestRequiredChange = onConfirmationRequestRequiredChange;
    vm.onConnectionTimeoutChange = onConnectionTimeoutChange;
    vm.onBidIdParsingChange = onBidIdParsingChange;
    vm.onDynamicNumberSecondStepParsingChange = onDynamicNumberSecondStepParsingChange;
    vm.onUpdateConfirmationRequestSettings = onUpdateConfirmationRequestSettings;
    vm.onUpdateHttpRequestSettings = onUpdateHttpRequestSettings;
    vm.onChangeAdvancedHttpUrl = onChangeAdvancedHttpUrl;
    vm.onChangeAdvancedHttpRequestBody = onChangeAdvancedHttpRequestBody;
    vm.onChangeAdvancedHttpRequestMethod = onChangeAdvancedHttpRequestMethod;
    vm.onChangeAdvancedConfirmationHttpUrl = onChangeAdvancedConfirmationHttpUrl;
    vm.onChangeAdvancedConfirmationHttpRequestBody = onChangeAdvancedConfirmationHttpRequestBody;
    vm.onChangeAdvancedConfirmationHttpRequestMethod = onChangeAdvancedConfirmationHttpRequestMethod;

    vm.onRefreshBuyers = onRefreshBuyers;
    vm.updateRevenueRecoverySetting = updateRevenueRecoverySetting;

    vm.onUpdateRequestSettingsHeaders = updateRequestSettingsHeaders;
    vm.onUpdateConfirmationRequestSettingsHeaders = updateConfirmationRequestSettingsHeaders;
    vm.onToggleSecondParsingStep = onToggleSecondParsingStep;
    vm.toggleSetHours = toggleSetHours;
    vm.onToggleSecondParsingStepAdvanced = onToggleSecondParsingStepAdvanced;
    vm.validateTagRoutingFilters = validateTagRoutingFilters;

    vm.basicAdvancedTooltip = $filter('translate')('PING_TREE_TARGET_BASIC_ADVANCED_PARSING_TT');

    vm.secondStepEnabled = false;
    vm.rttSharingRequestObject = {};
    vm.areParsingStepsComplete = false;

    vm.showBasicParsingWarningMessage = false;

    vm.ringbaToRingbaEnabled = false;

    vm.isTagRoutingFiltersInvalid = false;

    vm.onWeekDayMatrixUpdated = onWeekDayMatrixUpdated;
    vm.tagRoutingFilterGroupLogicTooltip = $filter('translate')('TAG_ROUTING_FILTERS_GROUP_BY_TT');

    vm.onConversionTypeSelect = onConversionTypeSelect;

    vm.macros = macros;
    vm.appendToken = appendToken;

    const defaultParsingStep = {
      property: '',
      operator: { label: 'Equals', value: '===' },
      value: ''
    };

    const defaultRequestSettingProperty = {
      property: '',
    };

    vm.requestSettingsObject = {
      url: vm.currentPingTreeTarget?.url || '',
      method: vm.currentPingTreeTarget?.method || 'get',
      body: vm.currentPingTreeTarget?.body || '',
      headers: vm.currentPingTreeTarget?.headers || {},
      authentication: vm.currentPingTreeTarget?.authConnection?.id || null,
      contentType: vm.currentPingTreeTarget?.contentType || 'application/json'
    };

    vm.confirmationRequestSettingsObject = {
      url: vm.currentPingTreeTarget?.bidAcceptanceSettings?.url || '',
      method: vm.currentPingTreeTarget?.bidAcceptanceSettings?.method || 'get',
      body: vm.currentPingTreeTarget?.bidAcceptanceSettings?.body || '',
      headers: vm.currentPingTreeTarget?.bidAcceptanceSettings?.headers || null,
      contentType: vm.currentPingTreeTarget?.bidAcceptanceSettings?.contentType || 'application/json'
    };

    vm.acceptanceParsingBasic = [{ ...defaultParsingStep }];
    vm.dynamicNumberParsingBasic = [{ ...defaultRequestSettingProperty }];
    vm.dynamicBidParsingBasic = [{ ...defaultRequestSettingProperty }];
    vm.dynamicDurationParsingBasic = [{ ...defaultRequestSettingProperty }];
    vm.bidIdParsingBasic = [{ ...defaultRequestSettingProperty }];
    vm.dynamicNumberSecondStepParsingBasic = [{ ...defaultRequestSettingProperty }];

    vm.setAdvancedParsingStepsValidity = setAdvancedParsingStepsValidity;
    vm.isFormInvalid = isFormInvalid;

    vm.advancedParsingValidity = {
      acceptanceParsing: {
        text: '',
        isInvalid: false,
      },
      dynamicNumberParsing: {
        text: '',
        isInvalid: false,
      }
    };

    vm.isRevenueRecoveryInvalid = false;
    // Revenue Recovery options, default starts out with generic label for parent setting
    vm.revenueRecoverySettingsOptions = [
      { name: $filter('translate')('USE_PARENT_SETTING'), value: null },
      { name: $filter('translate')('ENABLED_TEXT'), value: true },
      { name: $filter('translate')('DISABLED_TEXT'), value: false }
    ];

    function onInit() {
      vm.isAdmin = accountsService.isAdmin();
      _loadTimeZones();
      _loadBuyers();
      _loadEventCallBackMacros();
      _getTags();
      _loadConversionSettings();
      _getAuthConnections();

      vm.isReadOnly = accountsService.isBuyer();
      vm.currentPingTreeTarget = vm.currentPingTreeTarget || pingTreeTargetService.initNewTarget();
      vm.isPhoneNumberValid = !!vm.currentPingTreeTarget.id;
      _initIsRtbRTTResponse();
      _initOverrides();
      _initAuthConnection();
      _initRpcSettingItem();
      _initRevenueRecoveryParentSetting();

      _initRequestSettingsObjects();
      // Required to pass to Request Settings Basic
      sanitizeParsingObjects();
      createBidAcceptanceSettingsIfEmpty();
      vm.secondStepEnabled = vm.currentPingTreeTarget.bidAcceptanceSettings.enabled;
      validateTagRoutingFilters();
    }

    function _initIsRtbRTTResponse() {
      vm.isRtbRttResponse = vm.isRtbRttResponse !== undefined ? vm.isRtbRttResponse : {
        exposeCallerId: false,
        shareInboundCallId: false,
        rtbSettingsId: '',
        tags: [],
      };
      if (vm.isRtbRttResponse.exposeCallerId || vm.isRtbRttResponse.shareInboundCallId || vm.isRtbRttResponse.rtbSettingsId) {
        vm.ringbaToRingbaEnabled = true;
        vm.currentPingTreeTarget.isNumberDynamic = true;
      } else {
        vm.ringbaToRingbaEnabled = false;
      }
    }

    function _resetIsRtbRTTSettings() {
      vm.isRtbRttResponse = {
        exposeCallerId: false,
        shareInboundCallId: false,
        rtbSettingsId: '',
        tags: [],
      };
    }

    function _initRequestSettingsObjects() {
      createBidAcceptanceSettingsIfEmpty();
      vm.requestSettingsObject = {
        url: vm.currentPingTreeTarget?.url || '',
        method: vm.currentPingTreeTarget?.method || 'get',
        body: vm.currentPingTreeTarget?.body || '',
        headers: vm.currentPingTreeTarget?.headers || {},
        authentication: vm.currentPingTreeTarget?.authConnection?.id || null,
        contentType: vm.currentPingTreeTarget?.contentType || 'application/json'
      };
      vm.confirmationRequestSettingsObject = {
        url: vm.currentPingTreeTarget?.bidAcceptanceSettings?.url || '',
        method: vm.currentPingTreeTarget?.bidAcceptanceSettings?.method || 'get',
        body: vm.currentPingTreeTarget?.bidAcceptanceSettings?.body || '',
        headers: vm.currentPingTreeTarget?.bidAcceptanceSettings?.headers || {},
        contentType: vm.currentPingTreeTarget?.bidAcceptanceSettings?.contentType || 'application/json'
      };
    }

    function onChanges(changesObj) {
      if (changesObj.currentPingTreeTarget && typeof vm.currentPingTreeTarget !== 'undefined') {
        vm.isPhoneNumberValid = !!vm.currentPingTreeTarget.id;
        _initOverrides();
        _initAuthConnection();
        _initSecondStep();
        toggleSetHours();
        vm.cannotBuyerSetConcurrencyCap = accountsService.isBuyer() && !_getCanSetConcurrencyCapPermission(vm.currentPingTreeTarget);
        vm.targetOwnerCopy = angular.copy(vm.currentPingTreeTarget.owner);
        if (vm.currentPingTreeTarget.owner && vm.currentPingTreeTarget.owner.routeDuplicates) {
          vm.routeDuplicatesBuyer = angular.copy(vm.currentPingTreeTarget.owner.routeDuplicates);
        } else {
          vm.routeDuplicatesBuyer = null;
        }

        if (vm.currentPingTreeTarget.schedule) {
          _initializeCallCaps();
          if (vm.currentPingTreeTarget.schedule.callConcurrencyMatrix && vm.currentPingTreeTarget.schedule.callConcurrencyMatrix.length > 0) {
            vm.setConcurrency = true;
            if (!_isBasic(vm.currentPingTreeTarget.schedule.callConcurrencyMatrix)) {
              vm.showAdvancedConcurrency = true;
            }
          }
        }
        _checkAndShowTagFilter();
        _initRpcSettingItem();
        _initRevenueRecoveryParentSetting();
        validateTagRoutingFilters();
      }

      _initRequestSettingsObjects();
      if (changesObj.isRtbRttResponse) {
        _initIsRtbRTTResponse();
      }

      // Required to pass to Request Settings Basic
      sanitizeParsingObjects();
    }

    function validateTagRoutingFilters() {
      if (vm.currentPingTreeTarget.criteria?.length) {
        vm.isTagRoutingFiltersInvalid = vm.currentPingTreeTarget.criteria.some(criteria => criteria.tagCriteria.some(tc => !tc.tagIds[0]));
      }
    }

    function onToggleRTBShareableTags() {
      // This function evaluates before the setting is toggled, so if ringbaToRingbaEnabled is false, it is being toggled on
      if (!vm.ringbaToRingbaEnabled) {
        vm.currentPingTreeTarget.isNumberDynamic = true;
        vm.overrideRevenueSettings = true;
        vm.currentPingTreeTarget.revenueSettings.revenueDynamic = true;
        vm.currentPingTreeTarget.revenueSettings.revenueOnFailure = 0;
        vm.currentConversionSettings.conversionType = 'callLength';
        vm.currentConversionSettings.conversionArgs = {};
        vm.currentConversionSettings.conversionArgs.startTimerEvent = 'OnConnectedCall';
        vm.currentPingTreeTarget.revenueSettings.conversionCallLengthDynamic = true;
        vm.overrideMinRevenueSetting = false;
      }

      if (vm.ringbaToRingbaEnabled) {
        vm.currentPingTreeTarget.isNumberDynamic = false;
        
        // When toggling shareable tags off, set to Advanced Parsing
        vm.currentPingTreeTarget.isBasic = false;
      }

    }

    function onRPCSettingToggled(isEnabled) {
      if (isEnabled == null) {
        // account setting will take precedence
        vm.isRpcSettingReadOnly = true;
        vm.rpcSettingInContext = vm.parentRPCSettings;

        return;
      }

      vm.isRpcSettingReadOnly = false;
      vm.rpcSettingInContext = {
        erpcSetting: null,
        useERPC: isEnabled.value
      };

      vm.overrideRpcSetting = isEnabled.value;
      vm.rpcItem = {
        enabled: isEnabled.value,
        id: ''
      };
    }

    function onRPCSettingsChange(value) {
      vm.rpcSettingInContext = value;
    }

    function onRPCChange(value) {
      vm.rpcItem.id = value;
    }

    function onPriorityBumpChange(value) {
      vm.currentPingTreeTarget.priorityBump = value;
    }

    function _getCanSetConcurrencyCapPermission(target) {
      return target && target.owner && target.owner.canSetConcurrencyCaps;
    }

    function showOwner() {
      return !accountsService.isBuyer();
    }


    function setSelectedOwner() {
      if (vm.currentPingTreeTarget.owner && vm.currentPingTreeTarget.owner.id) {
        vm.routeDuplicatesBuyer = vm.buyers.find(function (buyer) { return buyer.id === vm.currentPingTreeTarget.owner.id; }).routeDuplicates;
      } else {
        vm.routeDuplicatesBuyer = null;
      }
      _initRevenueRecoveryParentSetting();
    }

    function onTargetDupeSettingsChange(value) {
      vm.currentPingTreeTarget.routeDuplicates = value;

    }

    function showType() {
      return !accountsService.isBuyer();
    }

    function onScheduleChange(hoursOfOperation) {
      vm.currentPingTreeTarget.schedule = vm.currentPingTreeTarget.schedule || {};
      vm.currentPingTreeTarget.schedule.hoursOfOperation = hoursOfOperation;
    }

    function save() {
      createBidAcceptanceSettingsIfEmpty();
      vm.currentPingTreeTarget.bidAcceptanceSettings.enabled = vm.secondStepEnabled;

      if (vm.overrideRevenueSettings) {
        vm.currentPingTreeTarget.revenueSettings.conversionParams = vm.currentConversionSettings;
      }
      else {
        vm.currentPingTreeTarget.revenueSettings = null;
      }

      if (!vm.overrideMinRevenueSetting) {
        vm.currentPingTreeTarget.minRevenueToRoute = null;
      }

      if (!vm.overrideErrorSettings) {
        vm.currentPingTreeTarget.errorSettings = null;
      }

      if (!vm.secondStepEnabled) {
        vm.currentPingTreeTarget.bidAcceptanceSettings = null;
      }

      // Save function errors if method is not present.
      if (vm.currentPingTreeTarget?.bidAcceptanceSettings && !vm.currentPingTreeTarget.bidAcceptanceSettings?.method) {
        vm.currentPingTreeTarget.bidAcceptanceSettings.method = 'get';
      }

      if (accountsService.isBuyer() && !vm.cannotBuyerSetConcurrencyCap) {
        return _saveBuyerConcurrencyCap().then(function (updatedTarget) {
          vm.onSave({
            $event: {
              pingTreeTarget: updatedTarget
            }
          });
        });
      } else if (vm.isAdmin) {
        vm.currentPingTreeTarget.rpcSetting = (!vm.isRpcSettingReadOnly ? this.rpcSettingInContext : null);
        return _createUpdateTarget().then(function (updateTarget) {
          if (updateTarget) {
            vm.onSave({
              $event: {
                newPingTreeTarget: !vm.currentPingTreeTarget.id,
                pingTreeTarget: updateTarget
              }
            });
            vm.targetOwnerCopy = angular.copy(updateTarget.owner);
            return updateTarget;
          }
        }).then(updatedTarget => {
          _resetIsRtbRTTSettings();
          pingTreeTargetService.getTarget(accountsService.currentAccountId, updatedTarget.id).then(response => {
            const refreshedTarget = response.data.pingTreeTarget;
            vm.currentPingTreeTarget = pingTreeTargetService.formatParsers(refreshedTarget);
            vm.isRtbRttResponse = response.data.isRtbRTTResponse;
            _initIsRtbRTTResponse();
          });
        })
          .catch(error => {
            utils.errorHandler(error.message);
          });
      }
      return $q.when({});
    }

    function _saveBuyerConcurrencyCap() {
      _resetCallCaps();
      return pingTreeTargetService.buyerSetConcurrencyCap(accountsService.currentAccountId, vm.currentPingTreeTarget.id, {
        callConcurrencyMatrix: vm.currentPingTreeTarget.schedule.callConcurrencyMatrix,
        concurrencyCap: vm.currentPingTreeTarget.schedule.concurrencyCap,
        callCapMatrix: vm.currentPingTreeTarget.schedule.callCapMatrix,
        allTimeCap: vm.currentPingTreeTarget.schedule.allTimeCap,
        monthlyCap: vm.currentPingTreeTarget.schedule.monthlyCap,
        dailyCap: vm.currentPingTreeTarget.schedule.dailyCap,
        hourlyCap: vm.currentPingTreeTarget.schedule.hourlyCap,
        dailyCapDayOfWeek: vm.currentPingTreeTarget.schedule.dailyCapDayOfWeek
      }).then(function (response) {
        toaster.pop('success', $filter('translate')('TARGET_CC_UPDATE_SUCCESS'));
        return response.data.target;
      }).catch(error => {
        utils.errorHandler(error);
      });
    }

    function validateDuplicacy(newValue) {
      if (newValue) {
        pingTreeTargetService.checkIfDuplicate(accountsService.currentAccountId, {
          id: vm.currentPingTreeTarget.id,
          name: vm.currentPingTreeTarget.name,
          accountId: vm.currentPingTreeTarget.accountId
        }).then(function (response) {
          /*
          if (vm.newPingTreeTargetForm.phoneNumber) {
            vm.newPingTreeTargetForm.phoneNumber.$setValidity("duplicate", !response.data.isDuplicatePhoneNumber);
          }

          if (vm.newPingTreeTargetForm.SIPNumber) {
            vm.newPingTreeTargetForm.SIPNumber.$setValidity("duplicate", !response.data.isDuplicateSIP);
          }*/

          if (vm.newPingTreeTargetForm && vm.newPingTreeTargetForm.name) {
            vm.newPingTreeTargetForm.name.$setValidity('duplicate', !response.data.isDuplicateName);
          }
        });
      }
    }

    function showTagFilterSection() {
      vm.isTagFilterSectionOpen = true;
      vm.showFullWidthOptions.showSummaryView = false;
    }

    function removeAllFilters() {
      vm.isTagFilterSectionOpen = false;
      vm.currentPingTreeTarget.criteria = [];
    }

    function resetCapCounters() {
      return pingTreeTargetService.resetCallCounters(accountsService.currentAccountId, vm.currentPingTreeTarget.id)
        .then(function () {
          toaster.pop('success', $filter('translate')('RESET_COUNTERS_SUCCESS'));
          vm.cancelModal();
        })
        .catch(error => {
          utils.errorHandler(error);
        });
    }

    function confirmResetCapCounters() {
      vm.modalBodyText = $filter('translate')('RESET_COUNTERS_MODAL_BODY', { target: 'Target' });
      vm.modal = $uibModal.open({
        templateUrl: '/scripts/shared/components/select-target/reset-target-counters.modal.html',
        scope: $scope,
        controllerAs: 'vm'
      });
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
      }
    }

    function emptyConcurrency() {
      vm.callCaps.concurrencyCap = -1;
    }

    async function _deferredOnUpdate(promiseTarget, isUpdate) {
      const response = await promiseTarget;
      const target = response.data.pingTreeTarget;

      const parseSettings = target.parseSettings || {};
      const bidAcceptanceSettings = target.bidAcceptanceSettings || pingTreeTargetService.initBidAcceptanceSettings();
      if (bidAcceptanceSettings.method) {
        bidAcceptanceSettings.method = bidAcceptanceSettings.method.toLowerCase();
      }
      const parseSettingsSecondStep = bidAcceptanceSettings.parseSettings || {};

      target.dynamicBidAmountParser = (parseSettings.bidAmount || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      target.shouldAcceptCallParser = (parseSettings.acceptCall || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      target.dynamicDialSettingParser = (parseSettings.dynamicDial || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      target.dynamicCallLengthSettingParser = (parseSettings.dynamicCallLength || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      target.bidIDParseSettingsParser = (bidAcceptanceSettings.bidIDParseSettings || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });
      target.dynamicDialSettingParserSecondStep = (parseSettingsSecondStep.dynamicDial || []).map(function (element) {
        return { parserType: element.type.toLowerCase(), Value: element.value };
      });


      function onSuccess() {
        toaster.pop('success', $filter('translate')(isUpdate ? 'PING_TREE_TARGET_UPDATE_SUCCESS' : 'PING_TREE_TARGET_CREATE_SUCCESS'));
        return target;
      }

      if (vm.currentCallRoute && vm.addRouteEnabled) {
        vm.currentCallRoute.targetid = target.id;
        vm.currentCallRoute.callTarget = target;
        return vm.addRoute({ route: vm.currentCallRoute })
          .then(onSuccess)
          .catch(function (error) {
            utils.errorHandler(error);
            return error;
          });
      } else {
        return onSuccess();
      }
    }

    function _handleDuplicateError(response) {
      if (response.data.isDuplicate) {
        let message = 'TARGET_ERROR_DUP_GENERAL';

        if (response.data.isDuplicateName) {
          message = 'TARGET_ERROR_DUP_NAME';
          vm.newPingTreeTargetForm.name.$setValidity('duplicate', false);
        }

        if (response.data.isDuplicatePhoneNumber) {
          message = 'TARGET_ERROR_DUP_PHONE';
        }

        if (response.data.isDuplicateSIP) {
          message = 'TARGET_ERROR_DUP_SIP';
        }

        return $q.reject({
          data: {
            message: $filter('translate')(message)
          }
        });
      } else {
        return $q.reject(response);
      }
    }

    function onCallTypeChange($event) {
      vm.currentPingTreeTarget.instructions.callType = $event.newValue;
    }

    function onNumberChange(numberChange) {
      vm.currentPingTreeTarget.instructions.number = numberChange.phoneNumber;
      vm.isPhoneNumberValid = numberChange.isValid;
    }

    function updateRequestSettingsHeaders(headers) {
      vm.currentPingTreeTarget.headers = headers;
    }


    function sanitizeRequestPropertyForDisplay(parseSettings = [{ ...defaultRequestSettingProperty }]) {

      if (!parseSettings.length) return [{ ...defaultRequestSettingProperty }];

      try {
        const returnValue = { property: parseSettings[0].value };

        return [{ ...returnValue }];
      } catch {
        return [{ ...defaultRequestSettingProperty }];
      }
    }

    // Utilized to pass down correct format for display to Request Settings / Confirmation Request Settings Vue Components.
    function sanitizeParsingForDisplay(parsing) {
      try {
        const acceptanceParsingComparisonConfig = {
          options: [
            { label: 'Equals', value: '===' },
            { label: 'Does Not Equal', value: '!=' },
            { label: 'Greater Than', value: '>' },
            { label: 'Less Than', value: '<' }
          ],
          placeholder: 'Choose Operator'
        };
        const operatorRegex = />|<|===|!=/;
        const valueRegex = /"([^"]+)"/;
        const valueRegexForGreaterOrLessThan = /\b(\d+)\b/;

        const returnValue = [];
        const chunkArray = [];

        // Split the array into groups of 2, this is needed for the next step
        for (let i = 0; i < parsing.length; i += 2) {
          const parseSetting = parsing.slice(i, i + 2);
          chunkArray.push(parseSetting);
        }

        chunkArray.forEach(parseSetting => {
          parseSetting = parseSetting.map(setting => {
            if (setting.Value) {
              setting.value = setting.Value;
            }
            return setting;
          });

          const operatorMatch = parseSetting[1].value.match(operatorRegex);
          const operator = operatorMatch[0];

          let valueMatch;

          if (operator === '>' || operator === '<') {
            valueMatch = parseSetting[1].value.match(valueRegexForGreaterOrLessThan);
          } else {
            valueMatch = parseSetting[1].value.match(valueRegex);
          }
          const value = valueMatch[1].trim();

          const pathArray = parseSetting[0].value.split('.');
          const label = pathArray?.length > 1 ? `${pathArray[pathArray.length - 2]} > ${pathArray.pop()}` : pathArray.pop();
          const operatorObject = acceptanceParsingComparisonConfig.options.find(op => op.value === operator);



          const acceptanceParsing =
            {
              property: label,
              path: parseSetting[0].value,
              operator: {
                label: operatorObject.label,
                value: operatorObject.value
              },
              value: value
            };

          returnValue.push(acceptanceParsing);
        });

        return returnValue;
      } catch {
        return [{ ...defaultParsingStep }];
      }
    }

    function setParsingSettingsValidation() {
      if (!isParsingValid(vm.acceptanceParsingBasic)) {
        vm.areParsingStepsComplete = false;
        return;
      }

      if (vm.currentPingTreeTarget.isNumberDynamic && !vm.currentPingTreeTarget.bidAcceptanceSettings.numberRequired && !isParsingValid(vm.dynamicNumberParsingBasic)) {
        vm.areParsingStepsComplete = false;
        return;
      }

      if (vm.currentPingTreeTarget.revenueSettings?.revenueDynamic && vm.overrideRevenueSettings && !isParsingValid(vm.dynamicBidParsingBasic)) {
        vm.areParsingStepsComplete = false;
        return;
      }

      if (vm.currentPingTreeTarget.revenueSettings?.conversionCallLengthDynamic && vm.overrideRevenueSettings && !isParsingValid(vm.dynamicDurationParsingBasic)) {
        vm.areParsingStepsComplete = false;
        return;
      }

      if (vm.currentPingTreeTarget.bidAcceptanceSettings.enabled && vm.currentPingTreeTarget.bidAcceptanceSettings.bidIDRequired && !isParsingValid(vm.bidIdParsingBasic)) {
        vm.areParsingStepsComplete = false;
        return;
      }

      if (vm.currentPingTreeTarget.bidAcceptanceSettings.enabled && vm.currentPingTreeTarget.bidAcceptanceSettings.numberRequired && !isParsingValid(vm.dynamicNumberSecondStepParsingBasic)) {
        vm.areParsingStepsComplete = false;
        return;
      }

      vm.areParsingStepsComplete = true;

      function isParsingValid(parser) {
        let isValid = true;

        if (!parser.length) isValid = false;

        parser.forEach(item => {
          if (Object.hasOwn(item, 'value') && !item.value) {
            isValid = false;
          }

          if (!item.property) {
            isValid = false;
          }
        });

        return isValid;
      }
    }

    function sanitizeParsingObjects() {
      try {
        if (vm.currentPingTreeTarget?.parseSettings) {
          vm.acceptanceParsingBasic = sanitizeParsingForDisplay(vm.currentPingTreeTarget.parseSettings.acceptCall);
          vm.dynamicNumberParsingBasic = sanitizeRequestPropertyForDisplay(vm.currentPingTreeTarget.parseSettings.dynamicDial);
          vm.dynamicBidParsingBasic = sanitizeRequestPropertyForDisplay(vm.currentPingTreeTarget.parseSettings.bidAmount);
          vm.dynamicDurationParsingBasic = sanitizeRequestPropertyForDisplay(vm.currentPingTreeTarget.parseSettings.dynamicCallLength);
        }

        if (vm.currentPingTreeTarget?.bidAcceptanceSettings) {
          vm.bidIdParsingBasic = sanitizeRequestPropertyForDisplay(vm.currentPingTreeTarget.bidAcceptanceSettings.bidIDParseSettings).length ? sanitizeRequestPropertyForDisplay(vm.currentPingTreeTarget.bidAcceptanceSettings.bidIDParseSettings) : [{ ...defaultRequestSettingProperty }];
          vm.dynamicNumberSecondStepParsingBasic = sanitizeRequestPropertyForDisplay(vm.currentPingTreeTarget.bidAcceptanceSettings.parseSettings.dynamicDial).length ? sanitizeRequestPropertyForDisplay(vm.currentPingTreeTarget.bidAcceptanceSettings.parseSettings.dynamicDial) : [{ ...defaultRequestSettingProperty }];
        }

        setParsingSettingsValidation();
      } catch (error) {
        utils.errorHandler(error);
      }
    }

    function translateBasicToAdvanced(parseSetting) {
      return parseSetting.map(setting => {
        return {
          parserType: setting.parserType.toLowerCase(),
          Value: setting.value
        };
      });
    }

    function resetSettingsForBasic() {
      vm.acceptanceParsingBasic = [{ ...defaultParsingStep }];
      vm.dynamicNumberParsingBasic = [{ ...defaultRequestSettingProperty }];
      vm.dynamicBidParsingBasic = [{ ...defaultRequestSettingProperty }];
      vm.dynamicDurationParsingBasic = [{ ...defaultRequestSettingProperty }];
      vm.bidIdParsingBasic = [{ ...defaultRequestSettingProperty }];
      vm.dynamicNumberSecondStepParsingBasic = [{ ...defaultRequestSettingProperty }];

      vm.showBasicParsingWarningMessage = true;
      setParsingSettingsValidation();
    }

    function onAcceptanceParsingChange(payload) {
      vm.currentPingTreeTarget.shouldAcceptCallParser = translateBasicToAdvanced(payload);
      setParsingSettingsValidation();
    }
    function onDynamicNumberParsingChange(payload) {
      vm.currentPingTreeTarget.dynamicDialSettingParser = translateBasicToAdvanced(payload);
      setParsingSettingsValidation();
    }
    function onDynamicBidParsingChange(payload) {
      vm.currentPingTreeTarget.dynamicBidAmountParser = translateBasicToAdvanced(payload);
      setParsingSettingsValidation();
    }
    function onDynamicDurationParsingChange(payload) {
      vm.currentPingTreeTarget.dynamicCallLengthSettingParser = translateBasicToAdvanced(payload);
      setParsingSettingsValidation();
    }


    // CONFIRMATION REQUEST SETTINGS BASIC
    function createBidAcceptanceSettingsIfEmpty() {
      if (vm.currentPingTreeTarget && !vm.currentPingTreeTarget?.bidAcceptanceSettings) {
        vm.currentPingTreeTarget.bidAcceptanceSettings = pingTreeTargetService.initBidAcceptanceSettings();
      }
    }
    // Need this to be callable from the html
    function onToggleSecondParsingStepAdvanced(payload) {
      if (payload === true) return;
      vm.currentPingTreeTarget.bidAcceptanceSettings.numberRequired = false;
    }

    function onToggleSecondParsingStep(payload) {
      vm.secondStepEnabled = payload;

      if (payload === false) {
        vm.currentPingTreeTarget.bidAcceptanceSettings.numberRequired = false;
      }
    }
    function onBidIdRequiredChange(payload) {
      createBidAcceptanceSettingsIfEmpty();
      if (vm.currentPingTreeTarget?.bidAcceptanceSettings) {
        vm.currentPingTreeTarget.bidAcceptanceSettings.bidIDRequired = payload;
      }
    }
    function onUseConfirmationRequestNumberChange(payload) {
      createBidAcceptanceSettingsIfEmpty();
      vm.currentPingTreeTarget.bidAcceptanceSettings.numberRequired = payload;
    }
    function onConfirmationRequestRequiredChange(payload) {
      createBidAcceptanceSettingsIfEmpty();
      vm.currentPingTreeTarget.bidAcceptanceSettings.required = payload;
    }
    function onConnectionTimeoutChange(payload) {
      createBidAcceptanceSettingsIfEmpty();
      vm.currentPingTreeTarget.bidAcceptanceSettings.pingTimeoutInMS = payload;
    }
    function onBidIdParsingChange(payload) {
      vm.currentPingTreeTarget.bidIDParseSettingsParser = payload.map(item => {
        return {
          parserType: item.parserType,
          Value: item.value
        };
      });
      setParsingSettingsValidation();
    }
    function onDynamicNumberSecondStepParsingChange(payload) {
      vm.currentPingTreeTarget.dynamicDialSettingParserSecondStep = payload.map(item => {
        return {
          parserType: item.parserType,
          Value: item.value
        };
      });
      setParsingSettingsValidation();
    }

    function onUpdateConfirmationRequestSettings(payload) {
      createBidAcceptanceSettingsIfEmpty();
      vm.currentPingTreeTarget.bidAcceptanceSettings.url = payload.url;
      vm.currentPingTreeTarget.bidAcceptanceSettings.method = payload.method;
      vm.currentPingTreeTarget.bidAcceptanceSettings.body = payload.body;
      vm.currentPingTreeTarget.bidAcceptanceSettings.headers = payload.headers;
      vm.currentPingTreeTarget.bidAcceptanceSettings.contentType = 'application/json';

      // This is for passing back down to Http Request Component
      vm.confirmationRequestSettingsObject = { ...payload, contentType: 'application/json' };
    }

    function onUpdateHttpRequestSettings(payload) {
      vm.currentPingTreeTarget.url = payload.url;
      vm.currentPingTreeTarget.method = payload.method;
      vm.currentPingTreeTarget.body = payload.body;
      vm.authenticationConnectionsId = payload.authentication;
      vm.currentPingTreeTarget.headers = payload.headers;
      vm.currentPingTreeTarget.contentType = 'application/json';

      // This is for passing back down to Http Request Component
      vm.requestSettingsObject = { ...payload, contentType: 'application/json' };
    }

    function onChangeAdvancedHttpUrl(url) {
      vm.currentPingTreeTarget.url = url;
      vm.requestSettingsObject.url = url;
    }

    function onChangeAdvancedHttpRequestMethod(method) {
      vm.requestSettingsObject.method = method;
    }

    function onChangeAdvancedHttpRequestBody(body) {
      vm.currentPingTreeTarget.body = body;
      vm.requestSettingsObject.body = body;
    }

    function onChangeAdvancedConfirmationHttpUrl(url) {
      vm.currentPingTreeTarget.bidAcceptanceSettings.url = url;
      vm.confirmationRequestSettingsObject.url = url;
    }

    function onChangeAdvancedConfirmationHttpRequestMethod(method) {
      vm.confirmationRequestSettingsObject.method = method;
    }

    function onChangeAdvancedConfirmationHttpRequestBody(body) {
      vm.currentPingTreeTarget.bidAcceptanceSettings.body = body;
      vm.confirmationRequestSettingsObject.body = body;
    }

    function updateConfirmationRequestSettingsHeaders(headers) {
      vm.currentPingTreeTarget.bidAcceptanceSettings.headers = headers;
    }

    function matrixUpdated(newVal) {
      vm.currentPingTreeTarget.schedule = vm.currentPingTreeTarget.schedule || {};
      vm.currentPingTreeTarget.schedule.callCapMatrix = newVal;
    }

    function setAdvancedParsingStepsValidity() {
      vm.advancedParsingValidity.acceptanceParsing.isInvalid = !vm.currentPingTreeTarget.isBasic && !vm.advancedParsingValidity.acceptanceParsing.text;
      vm.advancedParsingValidity.dynamicNumberParsing.isInvalid = (!vm.currentPingTreeTarget.isBasic && !vm.advancedParsingValidity.dynamicNumberParsing.text && vm.currentPingTreeTarget.isNumberDynamic && !vm.currentPingTreeTarget.bidAcceptanceSettings?.numberRequired);
    }

    function isFormInvalid() {
      // Allow buyer to bypass parsing validity checks
      if (vm.isReadOnly) {
        return vm.newPingTreeTargetForm.$invalid;
      }

      // Set Parsing Step Validity For Advanced Parsing Steps
      return vm.newPingTreeTargetForm.$invalid ||
        (!vm.currentPingTreeTarget.isNumberDynamic && !vm.currentPingTreeTarget.instructions.number && vm.currentPingTreeTarget.instructions.callType === 'number') ||
        (vm.currentPingTreeTarget && vm.currentPingTreeTarget.instructions.callType === 'number' && !vm.currentPingTreeTarget.isNumberDynamic && !vm.isPhoneNumberValid) ||
        (vm.rpcItem.enabled && !vm.rpcItem.id) ||
        (vm.currentPingTreeTarget.isBasic && !vm.areParsingStepsComplete && !vm.ringbaToRingbaEnabled) ||
        (!vm.currentPingTreeTarget.isBasic && !vm.advancedParsingValidity.acceptanceParsing.text) ||
        (!vm.currentPingTreeTarget.isBasic && !vm.advancedParsingValidity.dynamicNumberParsing.text && vm.currentPingTreeTarget.isNumberDynamic && !vm.currentPingTreeTarget.bidAcceptanceSettings?.numberRequired) ||
        vm.isTagRoutingFiltersInvalid ||
        vm.isRevenueRecoveryInvalid;
    }

    // TODO: Push this up to select target component
    async function _createUpdateTarget() {
      try {
        _resetCallCaps();
        _resetHours();
        let promiseTarget;
        const isUpdating = !!vm.currentPingTreeTarget.id;

        if (vm.ringbaToRingbaEnabled) {
          _processShareableTags();

          // Check if revenue type is set to Static, if so, make sure isBasic is set to False
          if (!vm.currentPingTreeTarget.revenueSettings?.revenueDynamic) {
            vm.currentPingTreeTarget.isBasic = false;
          }

          vm.rttSharingRequestObject['Tags'] = vm.currentPingTreeTarget.shareableTagSetting.macroTagstoShare;
          vm.rttSharingRequestObject['ExposeCallerId'] = vm.isRtbRttResponse.exposeCallerId;
          vm.rttSharingRequestObject['ShareInboundCallId'] = vm.isRtbRttResponse.shareInboundCallId;
          vm.rttSharingRequestObject['rtbSettingsId'] = vm.isRtbRttResponse.rtbSettingsId;
          try {
            await _handleBuildRTTSettings(vm.currentPingTreeTarget);
          } catch (err) {
            toaster.pop('error', err.data.message);
            return vm.currentPingTreeTarget;
          }
        } else {
          _resetShareableTags();
        }

        // Do not submit parsing steps if their options are not enabled on the form. Only stop submitting if Override Revenue Settings is turned on. If it's turned off, submit anyway.
        if ((!vm.currentPingTreeTarget?.isNumberDynamic || vm.currentPingTreeTarget?.bidAcceptanceSettings?.numberRequired) && vm.overrideRevenueSettings) {
          vm.currentPingTreeTarget.dynamicDialSettingParser = [];
        }
        if (!vm.currentPingTreeTarget.revenueSettings?.revenueDynamic && vm.overrideRevenueSettings) {
          vm.currentPingTreeTarget.dynamicBidAmountParser = [];
        }
        if (!vm.currentPingTreeTarget.revenueSettings?.conversionCallLengthDynamic && vm.overrideRevenueSettings) {
          vm.currentPingTreeTarget.dynamicCallLengthSettingParser = [];
        }

        // Wipe first step dynamic number parsing settings if using from second step, this is necessary
        if (vm.secondStepEnabled && vm.currentPingTreeTarget.bidAcceptanceSettings.numberRequired) {
          vm.currentPingTreeTarget.dynamicDialSettingParser = [];
        }

        if (vm.currentPingTreeTarget.isNumberDynamic && (!vm.secondStepEnabled || !vm.currentPingTreeTarget.bidAcceptanceSettings.numberRequired)) {
          vm.currentPingTreeTarget.dynamicDialSettingParserSecondStep = null;
        }

        // If there isn't an existing rpc object and a user created predictive routing config is selected, null out the rpcSetting object
        if (!vm.currentPingTreeTarget.rpc && vm.rpcItem?.id) {
          vm.currentPingTreeTarget.rpcSetting = null;
        }
        // If migrated predictive routing config was enabled but a user created predictive routing config is selected, null out the rpcSetting object
        if ((vm.currentPingTreeTarget.rpc?.id && vm.rpcItem?.id) && (vm.currentPingTreeTarget.rpc.id !== vm.rpcItem.id)) {
          vm.currentPingTreeTarget.rpcSetting = null;
        }
        // If user selects to use parent RPC settings, null out the rpcSetting object and reset priorityBump
        if (!vm.overrideRpcSetting) {
          vm.currentPingTreeTarget.rpcSetting = null;
        }

        try {
          if (isUpdating) {
            promiseTarget = await pingTreeTargetService.updateTarget(accountsService.currentAccountId, vm.currentPingTreeTarget);
            promiseTarget = await pingTreeTargetService.updateParseSettings(accountsService.currentAccountId, vm.currentPingTreeTarget);
          } else {
            promiseTarget = await pingTreeTargetService.createTarget(accountsService.currentAccountId, vm.currentPingTreeTarget);
          }
        } catch (error) {
          _handleDuplicateError(error);
          return;
        }
        await _handleLinkAuthConnection(promiseTarget);
        await _handleLinkRpc(promiseTarget);
        promiseTarget = await _linkBuyerToTarget(promiseTarget) || promiseTarget;

        return await _deferredOnUpdate(promiseTarget, isUpdating);

      } catch (exception) {
        utils.errorHandler(exception);
      }
    }

    function _processShareableTags() {
      vm.currentPingTreeTarget.shareableTagSetting = tagService.getShareableTags(vm.currentPingTreeTarget.shareableTagSetting, vm.availableTags);
    }

    function _resetShareableTags() {
      vm.currentPingTreeTarget.shareableTagSetting = null;
    }

    function _linkBuyerToTarget(response) {
      const targetId = response && response.data && response.data.pingTreeTarget && response.data.pingTreeTarget.id;
      let promise = $q.when(response);

      if (targetId) {
        if (vm.targetOwnerCopy
          && (!vm.currentPingTreeTarget.owner
            || !vm.currentPingTreeTarget.owner.id || vm.currentPingTreeTarget.owner.id != vm.targetOwnerCopy.id)) {
          promise = pingTreeTargetService.removeBuyer(accountsService.currentAccountId, targetId, vm.targetOwnerCopy.id);
        }
        if (vm.currentPingTreeTarget.owner && vm.currentPingTreeTarget.owner.id
          && (!vm.targetOwnerCopy || vm.currentPingTreeTarget.owner.id != vm.targetOwnerCopy.id || (vm.targetOwnerCopy && !vm.currentPingTreeTarget.id))) {
          return promise.then(function () {
            return pingTreeTargetService.addBuyer(accountsService.currentAccountId, targetId, vm.currentPingTreeTarget.owner.id);
          });
        }
      }
      return promise;
    }

    async function _handleBuildRTTSettings(target) {
      const pingTreeTarget = target;
      const responseObj = await pingTreeTargetService.buildRTTConfig(accountsService.currentAccountId, vm.rttSharingRequestObject);
      vm.currentPingTreeTarget.body = responseObj.data.body;

      // clear any current contents and make sure it exists on the current target
      pingTreeTarget.dynamicBidAmountParser = [{}];
      pingTreeTarget.dynamicCallLengthSettingParser = [{}];
      pingTreeTarget.shouldAcceptCallParser = [{}];
      pingTreeTarget.dynamicDialSettingParser = [{}];

      pingTreeTarget.dynamicBidAmountParser[0].parserType = 'JavaScript';
      pingTreeTarget.dynamicCallLengthSettingParser[0].parserType = 'JavaScript';
      pingTreeTarget.shouldAcceptCallParser[0].parserType = 'JavaScript';
      pingTreeTarget.dynamicDialSettingParser[0].parserType = 'JavaScript';

      pingTreeTarget.dynamicCallLengthSettingParser[0].value = responseObj.data.dynamicDurationParsing;
      pingTreeTarget.dynamicBidAmountParser[0].value = responseObj.data.dynamicBidParsing;
      pingTreeTarget.shouldAcceptCallParser[0].value = responseObj.data.callAcceptanceParsing;
      pingTreeTarget.dynamicDialSettingParser[0].value = responseObj.data.dynamicNumberParsing;

      pingTreeTarget.url = responseObj.data.url;
      pingTreeTarget.method = responseObj.data.method.toLowerCase();
    }

    async function _handleLinkAuthConnection(response) {
      const pingTreeTarget = response && response.data && response.data.pingTreeTarget;
      if (pingTreeTarget && pingTreeTarget.id) {

        if (vm.authenticationConnectionsId) {
          if (!pingTreeTarget.authConnection || vm.authenticationConnectionsId !== pingTreeTarget.authConnection.id) {
            return await pingTreeTargetService.linkToItem(accountsService.currentAccountId, pingTreeTarget.id, {
              memberName: 'AuthConnection',
              memberId: vm.authenticationConnectionsId
            });
          }
        } else {
          if (pingTreeTarget.authConnection) {
            return await pingTreeTargetService.unLinkItem(accountsService.currentAccountId, pingTreeTarget.id, {
              memberName: 'AuthConnection',
              memberId: pingTreeTarget.authConnection.id
            });
          }
        }
      }
    }

    async function _handleLinkRpc(response) {
      const pingTreeTarget = response && response.data && response.data.pingTreeTarget;
      if (pingTreeTarget && pingTreeTarget.id) {
        if (vm.rpcItem && vm.rpcItem.id) {
          if (vm.rpcItem.id.substr(0, 2) === 'PI' && vm.rpcItem.id.substr(-4) === 'LINK') return;
          if (!vm.currentPingTreeTarget.rpc || vm.rpcItem.id !== vm.currentPingTreeTarget.rpc.id || vm.currentPingTreeTarget.isDuplicate) {
            return await pingTreeTargetService.linkToItem(accountsService.currentAccountId, pingTreeTarget.id, {
              memberName: 'RPC',
              memberId: vm.rpcItem.id
            });
          }
        } else {
          if (vm.currentPingTreeTarget.rpc && vm.currentPingTreeTarget.rpc.id) {
            if (vm.currentPingTreeTarget.rpc.id.substr(0, 2) === 'PI' && vm.currentPingTreeTarget.rpc.id.substr(-4) === 'LINK') return;
            return await pingTreeTargetService.unLinkItem(accountsService.currentAccountId, pingTreeTarget.id, {
              memberName: 'RPC',
              memberId: vm.currentPingTreeTarget.rpc.id
            });
          }
        }
      }
    }

    // TODO: Push this up to the select-target component
    function _loadTimeZones() {
      infoService.getTimeZones()
        .then(function (response) {
          vm.timeZones = response.data;
        });
    }

    function _getAuthConnections() {
      if (accountsService.isBuyer()) return;

      authConnectionService.getAuthConnections(accountsService.currentAccountId).then(function (response) {
        vm.authConnections = response.data.authConnections;
      });
    }

    // Set values for call cap toggles
    function _initializeCallCaps() {
      capSettingsService.sanitizeCapPerDayOfWeekFromSingleValue(vm.currentPingTreeTarget.schedule, 'dailyCap', 'dailyCapDayOfWeek');

      if (vm.currentPingTreeTarget.schedule.allTimeCap >= 0) { vm.callCaps.allTimeCap = 1; } else { delete vm.currentPingTreeTarget.schedule.allTimeCap; }
      if (vm.currentPingTreeTarget.schedule.monthlyCap >= 0) { vm.callCaps.monthlyCap = 1; } else { delete vm.currentPingTreeTarget.schedule.monthlyCap; }

      if (vm.currentPingTreeTarget.schedule.dailyCap >= 0) { vm.callCaps.dailyCap = 1; } else { delete vm.currentPingTreeTarget.schedule.dailyCap; }
      if (vm.currentPingTreeTarget.schedule.concurrencyCap >= 0) { vm.callCaps.concurrencyCap = 1; } else { delete vm.currentPingTreeTarget.schedule.concurrencyCap; }

      if (vm.currentPingTreeTarget.schedule.dailyCapDayOfWeek != undefined && vm.currentPingTreeTarget.schedule.dailyCapDayOfWeek.length > 0) {
        vm.callCaps.dailyCap = 1;
      }

      vm.currentPingTreeTarget.schedule.dailyCapDayOfWeek = capSettingsService.sanitizeDOWCapToDisplay(vm.currentPingTreeTarget.schedule.dailyCapDayOfWeek);

      if (vm.currentPingTreeTarget.schedule.callCapMatrix != null) {
        //set -1 to nulls
        for (let day = 0; day < 7; day++) {
          for (let hour = 0; hour < 24; hour++) {
            if (vm.currentPingTreeTarget.schedule.callCapMatrix[day][hour] == -1) {
              vm.currentPingTreeTarget.schedule.callCapMatrix[day][hour] = null;
            }
          }
        }

        const allSame = _isBasicHourlyCap(vm.currentPingTreeTarget.schedule.callCapMatrix);
        if (allSame && vm.currentPingTreeTarget.schedule.callCapMatrix[0][0] == null) {
          vm.currentPingTreeTarget.schedule.callCapMatrix = null;
        }
      }

      if (vm.currentPingTreeTarget.schedule.hourlyCap >= 0 || vm.currentPingTreeTarget.schedule.callCapMatrix != null) {
        vm.callCaps.hourlyCap = 1;

        if (vm.currentPingTreeTarget.schedule.callCapMatrix == null) {
          //build matrix with full data.
          vm.currentPingTreeTarget.schedule.callCapMatrix = targetService.createMatrix(vm.currentPingTreeTarget.schedule.hourlyCap);
          //start discarding this property to only use the matrix
          vm.currentPingTreeTarget.schedule.hourlyCap = -1;
        }
      } else {
        delete vm.currentPingTreeTarget.schedule.hourlyCap;
        delete vm.currentPingTreeTarget.schedule.callCapMatrix;
      }

    }

    function _isBasicHourlyCap(matrix) {
      const compareHour = matrix[0][0];
      return _.every(matrix, function (day) {
        return _.every(day, function (hour) {
          return _.isEqual(hour, compareHour);
        });
      });
    }

    // Reset values of call caps based on toggle position
    function _resetCallCaps() {
      if (vm.callCaps.allTimeCap === -1) { vm.currentPingTreeTarget.schedule.allTimeCap = -1; }
      if (vm.callCaps.monthlyCap === -1) { vm.currentPingTreeTarget.schedule.monthlyCap = -1; }
      if (vm.callCaps.dailyCap === -1) {
        vm.currentPingTreeTarget.schedule.dailyCap = -1;
        vm.currentPingTreeTarget.schedule.dailyCapDayOfWeek = undefined;
      } else {
        vm.currentPingTreeTarget.schedule.dailyCapDayOfWeek = capSettingsService.sanitizeDOWCapToStore(vm.currentPingTreeTarget.schedule.dailyCapDayOfWeek);
      }

      if (vm.callCaps.hourlyCap === -1) { vm.currentPingTreeTarget.schedule.hourlyCap = -1; }
      if (vm.callCaps.hourlyCap === -1) {
        vm.currentPingTreeTarget.schedule.hourlyCap = -1;
        vm.currentPingTreeTarget.schedule.callCapMatrix = null;
      } else {
        vm.currentPingTreeTarget.schedule.callCapMatrix = vm.currentPingTreeTarget.schedule.callCapMatrix || targetService.createMatrix(undefined);
        //set nulls to -1
        for (let day = 0; day < 7; day++) {
          for (let hour = 0; hour < 24; hour++) {
            // if (vm.currentPingTreeTarget.schedule.callCapMatrix[day][hour] == null || vm.currentPingTreeTarget.schedule.callCapMatrix[day][hour] == '')
            if (vm.currentPingTreeTarget.schedule.callCapMatrix[day][hour] == null) {
              vm.currentPingTreeTarget.schedule.callCapMatrix[day][hour] = -1;
            }
          }
        }
      }
      _resetConcurrencyCaps();
    }

    function _resetConcurrencyCaps() {
      if (vm.callCaps.concurrencyCap === -1) { vm.currentPingTreeTarget.schedule.concurrencyCap = -1; }
      if (!vm.setConcurrency) { vm.currentPingTreeTarget.schedule.callConcurrencyMatrix = null; }
    }

    function _resetHours() {
      if (!vm.setHours) {
        vm.currentPingTreeTarget.schedule.hoursOfOperation = null;
      }
    }

    function _resetConversionSettings() {
      vm.currentConversionSettings.conversionArgs = {};
      delete vm.currentPingTreeTarget.revenueSettings.conversionCallLengthDynamic;
      delete vm.currentPingTreeTarget.revenueSettings.maxConversionCallDurationSeconds;
    }

    function _loadBuyers() {
      if (accountsService.isBuyer()) return;

      buyerService.getBuyers(accountsService.currentAccountId)
        .then(function (response) {
          vm.buyers = response.data.buyers;
          _loadAccountSettings();
        });
    }

    function _isBasic(matrix) {
      let basic = true;
      const compareDay = matrix[0];
      _.forEach(matrix, function (day) {
        if (!_.isEqual(compareDay, day)) {
          basic = false;
        }
      });
      return basic;
    }

    function _checkAndShowTagFilter() {
      if (vm.currentPingTreeTarget.criteria && vm.currentPingTreeTarget.criteria.length) {
        vm.isTagFilterSectionOpen = true;
        vm.showFullWidthOptions.showSummaryView = true;
      }
    }

    function _getTags() {
      tagService.getTags(accountsService.currentAccountId).then(function (response) {
        vm.availableTags = response.data;
      });
    }

    function _loadConversionSettings() {
      infoService.getConversionSettings()
        .then(function (response) {
          vm.conversionSettings = response.data;
        })
        .catch(error => {
          utils.errorHandler(error);
        });
    }

    function _tryGetBuyerRpcSettings() {
      if (vm.currentPingTreeTarget.owner && vm.currentPingTreeTarget.owner.id) {
        return vm.buyers.find(function (buyer) { return buyer.id === vm.currentPingTreeTarget.owner.id; }).rpcSetting;
      } else {
        return null;
      }
    }

    function _loadAccountSettings() {
      accountSettingsService.loadSettings(accountsService.currentAccountId)
        .then(function (response) {
          vm.accountSettings = response.data.accountSettings;

          _loadRpcSettingsInContext();
          _initRpcOptions();
        });
    }

    function _loadRpcSettingsInContext() {
      const buyerRpcSetting = _tryGetBuyerRpcSettings();

      if (buyerRpcSetting != null) {
        vm.parentRPCSettings = buyerRpcSetting;
        vm.parentRPCSettingLabel = $filter('translate')('USE_BUYER_SETTING');
        vm.buyerExternalLink = '/#/dashboard/buyer/' + vm.currentPingTreeTarget.owner.id;
      } else {
        vm.parentRPCSettingLabel = $filter('translate')('USE_CAMPAIGN_SETTING');
      }

      if (vm.currentPingTreeTarget.rpcSetting) {
        vm.rpcSettingInContext = vm.currentPingTreeTarget.rpcSetting;
        vm.isRpcSettingReadOnly = false;
      } else {
        vm.rpcSettingInContext = vm.parentRPCSettings;
        vm.isRpcSettingReadOnly = true;
      }
    }

    function _initOverrides() {
      vm.overrideMinRevenueSetting = vm.currentPingTreeTarget.minRevenueToRoute != null;
      vm.overrideRevenueSettings = !!vm.currentPingTreeTarget.revenueSettings;
      vm.overrideErrorSettings = !!vm.currentPingTreeTarget.errorSettings;

      vm.currentPingTreeTarget.revenueSettings = vm.currentPingTreeTarget.revenueSettings || { revenueDynamic: false };
      vm.currentConversionSettings = vm.currentPingTreeTarget.revenueSettings.conversionParams || {};
      vm.currentConversionSettings.conversionType = vm.currentConversionSettings.conversionType || 'connectedCall';

      vm.currentPingTreeTarget.errorSettings = vm.currentPingTreeTarget.errorSettings || {};

      // check for clean conversion settings; if not valid, fix
      if(vm.currentConversionSettings.conversionType != 'callLength') {
        _resetConversionSettings();
      }

    }

    function _initRpcSettingItem() {
      if (vm.currentPingTreeTarget.rpc && vm.currentPingTreeTarget.rpc.id) {
        vm.rpcItem = angular.copy(vm.currentPingTreeTarget.rpc);
        vm.overrideRpcSetting = true;
        return;
      }
      vm.rpcItem = {
        enabled: false,
        id: ''
      };
    }

    function _initRpcOptions() {
      vm.rpcOptions = [
        {
          name: vm.parentRPCSettingLabel,
          value: false
        },
        {
          name: $filter('translate')('USE_ERPC'),
          value: true
        }
      ];
    }

    function _initAuthConnection() {
      if (vm.currentPingTreeTarget.authConnection && vm.currentPingTreeTarget.authConnection.id) {
        vm.authenticationConnectionsId = vm.currentPingTreeTarget.authConnection.id || null;
      }
    }

    function _initSecondStep() {
      vm.secondStepEnabled = vm.currentPingTreeTarget != null && vm.currentPingTreeTarget.bidAcceptanceSettings != null;
      vm.bidAcceptanceSettings = vm.currentPingTreeTarget.bidAcceptanceSettings || pingTreeTargetService.initBidAcceptanceSettings();
      vm.bidAcceptanceSettings.contentType = vm.bidAcceptanceSettings.contentType || 'application/json';
    }

    function onWeekDayMatrixUpdated(newVal) {
      vm.currentPingTreeTarget.schedule = vm.currentPingTreeTarget.schedule || {};
      vm.currentPingTreeTarget.schedule.dailyCapDayOfWeek = newVal;
    }
    function _loadEventCallBackMacros() {
      if (accountsService.isBuyer()) return;

      callbackService.getEventCallBackMacros(accountsService.currentAccountId)
        .then(function (response) {
          vm.eventCallBackMacros = response.data.macros;
        })
        .catch(error => {
          utils.errorHandler(error);
        });
    }

    function onConversionTypeSelect(item) {
      if(item.name != 'callLength') {
        _resetConversionSettings();
      }
    }

    function macros() {
      return callbackService.macros;
    }

    function appendToken(selectedTag) {
      if (selectedTag && selectedTag.originalTag) {
        vm.currentPingTreeTarget.url += selectedTag.originalTag.macro;
      }
      // Wrapping in timeout so everything executes before this and focus is properly set
      $timeout(function () {
        angular.element('#ping-tree-target-url').focus();
      });
    }

    function toggleSetHours() {
      if (vm.currentPingTreeTarget?.schedule?.hoursOfOperation && !vm.setHours) {
        vm.setHours = true;
      }
    }

    function onRefreshBuyers() {
      vm.isRefreshingBuyers = true;
      try {
        _loadBuyers();
      } finally {
        $timeout(() => {
          vm.isRefreshingBuyers = false;
        }, 600);
      }
    }

    function updateRevenueRecoverySetting(setting) {
      vm.currentPingTreeTarget.hangupRerouteSetting = setting;
      vm.isRevenueRecoveryInvalid = vm.currentPingTreeTarget.hangupRerouteSetting?.maxRerouteAttempts > 5 || vm.currentPingTreeTarget.hangupRerouteSetting?.maxRerouteAttempts < 0;
    }
    // Based on whether the target has a buyer selected, set the first option name in the multi toggle
    function _initRevenueRecoveryParentSetting() {
      if (vm.currentPingTreeTarget.owner?.id) {
        vm.revenueRecoverySettingsOptions[0].name = $filter('translate')('USE_BUYER_SETTING');
      } else {
        vm.revenueRecoverySettingsOptions[0].name = $filter('translate')('USE_CAMPAIGN_SETTING');
      }
    }

    $scope.$on('onParsingValidationChange', setAdvancedParsingStepsValidity);
  }
})();
